module.exports = require("npm:@angular/common@2.0.0-rc.1/index.js");